<template>
  <div class="sp-template">
    <div class="h-title">线下充值审核</div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-form :inline="true" :model="conditions" size="small">
          <el-form-item>
            <el-form-item label="充值类型">
              <el-radio-group v-model="conditions.serviceType" size="small" @change="onSubmit">
                <el-radio-button v-if="in_configs(903)" :label="0">待处理</el-radio-button>
                <el-radio-button v-if="in_configs(904)" :label="1">已完成</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form-item>
          <el-form-item label="付款方">
            <el-select v-model="conditions.ownerOrgName" filterable clearable placeholder="请选择付款方" @change="onSubmit">
              <el-option v-for="item in ownerOrgNames" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="付款账户">
            <el-input v-model.lazy="conditions.accountRemark" placeholder="付款账户" clearable></el-input>
          </el-form-item>
          <el-form-item label="系统">
            <el-select v-model="conditions.system" filterable placeholder="请选择系统" @change="onSubmit">
              <el-option v-for="item in systems" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始日期">
            <el-date-picker v-model.lazy="conditions.startDate" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="结束日期">
            <el-date-picker v-model.lazy="conditions.endDate" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" clearable></el-date-picker>
          </el-form-item>
          <el-form-item label="描述">
            <el-select v-model="conditions.description" filterable clearable placeholder="请选描述" @change="onSubmit">
              <el-option v-for="item in descriptions" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="充值操作方">
            <el-select v-model="conditions.operator" filterable clearable placeholder="请选充值操作方" @change="onSubmit">
              <el-option v-for="item in operators" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-if="conditions.serviceType == 1" label="状态">
            <el-select v-model="conditions.auditStatus" filterable clearable placeholder="请选状态" @change="onSubmit">
              <el-option v-for="item in auditStatus" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button v-if="in_configs(901)" type="primary" @click="onSubmit">搜 索</el-button>
          </el-form-item>
          <el-button type="success" size="small" v-if="in_configs(902) && conditions.serviceType == 0" @click="batchAudit">审核</el-button>
          <el-button type="warning" size="small" v-if="in_configs(905) && conditions.serviceType == 0" @click="cancellation">作废</el-button>
        </el-form>
      </div>
      <!-- 线下充值 -->
      <el-table :data="depositData" stripe ref="multipleTable" @selection-change="handleSelectionChange" show-summary :summary-method="getSummaries" :key="Math.random()">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column v-if="conditions.serviceType == 1" prop="txId" label="交易号"></el-table-column>
        <el-table-column prop="customerOrgName" label="付款方"></el-table-column>
        <el-table-column prop="accountRemark" label="付款账户"></el-table-column>
        <el-table-column prop="bank" label="银行类型"></el-table-column>
        <el-table-column prop="actualAccountTime" label="实际到账时间"></el-table-column>
        <el-table-column prop="system" label="系统" :formatter="formatSytem"></el-table-column>
        <el-table-column prop="createDate" label="交易时间"></el-table-column>
        <el-table-column prop="currency" label="币种"></el-table-column>
        <el-table-column prop="amount" label="交易金额" sortable>
          <template slot-scope="scope">
            <span class="in">{{scope.row.amount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column label="充值凭证">
          <template slot-scope="scope">
            <img :src="'data:image/png;base64,'+scope.row.voucherImg" alt="充值凭证" width="60px" height="60px" style="cursor: pointer;" @click="checkImg()">
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="status" label="状态" :formatter="formatAuditStatus"></el-table-column>
        <el-table-column prop="operator" label="充值操作员"></el-table-column>
        <el-table-column v-if="conditions.serviceType == 0" label="操作">
          <template slot-scope="scope">
            <i v-if="in_configs(906)" class="el-icon-edit-outline" @click="offlineDepositEdit(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="conditions.currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="conditions.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="totalNums">
      </el-pagination>
      <el-dialog :visible="dialogShow" :before-close="handleClose">
        <iframe :src="url" width="100%" height="700px" frameborder="0"></iframe>
      </el-dialog>
      <transition name="el-fade-in-linear">
        <div class="modal" v-show="imgDialogShow" @click="closeModal()">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="img-wrapper">
                <div class="close" @click="closeModal()">
                  <i class="el-icon-circle-close-outline"></i>
                </div>
                <img id="imgContent" src="" alt="" style="max-width: 800px; max-height: 800px;">
              </div>
            </div>
          </div>
        </div>
      </transition>

      <el-dialog title="线下充值编辑" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('depositForm')" width="40%">
        <el-form :model="depositForm" status-icon :rules="rules" ref="depositForm">
          <el-form-item label="付款方:" :label-width="formLabelWidth">
            <span class="sub-title">{{depositForm.customerOrgName}}</span>
          </el-form-item>
          <el-form-item label="付款账户:" :label-width="formLabelWidth" prop="accountRemark">
            <el-input v-model="depositForm.accountRemark" size="medium" placeholder="付款账户" style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item label="系统:" :label-width="formLabelWidth">
            <span class="sub-title">{{depositForm.system}}</span>
          </el-form-item>
          <el-form-item label="交易时间:" :label-width="formLabelWidth">
            <span class="sub-title">{{depositForm.createDate}}</span>
          </el-form-item>
          <el-form-item label="充值方式:" :label-width="formLabelWidth">
            <el-radio v-model="depositForm.paymentTool" label="Offline_Alipay">线下支付宝</el-radio>
            <el-radio v-model="depositForm.paymentTool" label="BankTransfer">银行转账</el-radio>
            <el-radio v-model="depositForm.paymentTool" label="Rests">其他</el-radio>
          </el-form-item>

          <el-form-item label="银行类型" :label-width="formLabelWidth" v-if="depositForm.paymentTool=='BankTransfer'" prop="bank" class="is-required">
						<el-select v-model="depositForm.bank"  clearable>
              <el-option v-for="item in banks" :key="item.name" :label="item.name" :value="item.name"></el-option>
            </el-select>
					</el-form-item>

          <el-form-item label="实际到账时间" :label-width="formLabelWidth"  prop="actualAccountTime" class="is-required">
						<el-date-picker  v-model="depositForm.actualAccountTime" type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss" style="width:300px;"></el-date-picker>
					</el-form-item>

          <el-form-item label="充值操作员:" :label-width="formLabelWidth">
            <span class="sub-title">{{depositForm.operator}}</span>
          </el-form-item>
          <el-form-item label="交易金额:" :label-width="formLabelWidth" prop="amount">
            <el-input v-model="depositForm.amount" size="medium" placeholder="交易金额" style="width: 300px;">
              <template slot="append">{{depositForm.currency}}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="充值凭证:" :label-width="formLabelWidth" prop="voucherImg">
            <div class="img-content" v-if="!editImg">
              <img :src="'data:image/png;base64,'+depositForm.img" alt="充值凭证" width="148px" height="148px" style="cursor: pointer;" @click="checkImg()">
              <div class="mask">
                <i class="el-icon-delete" @click="editImg = true"></i>
              </div>
            </div>
            <el-upload v-if="editImg" action="#" :file-list="imgListCertificateImgs" accept="image/png,image/gif,image/jpg,image/jpeg" list-type="picture-card" :limit="1" :on-change="changeCertificateImg" :on-remove="rmCertificateImg" :auto-upload="false">
              <i class="el-icon-plus"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="备注:" :label-width="formLabelWidth" >
            <el-input type="textarea" v-model="depositForm.remarks" size="medium" placeholder="备注" style="width: 300px;" auto-complete="off"></el-input>
          </el-form-item>

        </el-form>
        
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('depositForm')">取 消</el-button>
          <el-button size="small" type="primary" @click="editOfflineDeposit('depositForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import vm from "../../main.js";
import { mapMutations } from "vuex";
export default {
  data() {
    var checkBank = (rule, value, callback) => {
      if(this.depositForm.paymentTool=='BankTransfer'){
        if(!this.depositForm.bank){
          return callback(new Error("请选择银行类型"));
        }
      }
      callback();      
    };
    var checkActualTime = (rule, value, callback) => {
      if(this.depositForm.paymentTool != '' && !this.depositForm.actualAccountTime){
          return callback(new Error("请输入实际到账时间"));
      }
      callback();      
    };
    return {
      show: true,
      gone: true,
      editImg: false,
      isProvider: true,
      billId: "",
      conditions: {
        id: "",
        orderId: "",
        ownerOrgName: "",
        system: "TMS",
        startDate: "",
        endDate: "",
        accountRemark: "",
        auditStatus: null,
        serviceType: 0,
        description: "",
        currentPage: 1,
        pageSize: 10
      },
      systems: [
        {
          value: "TMS",
          label: "TMS物流系统"
        },
        {
          value: "PP",
          label: "小包物流系统"
        },
        {
          value: "WMS",
          label: "WMS仓库系统"
        }
      ],
      banks: [
        {id: 'zhongxin', name: '中信银行'},
        {id: 'zhaoshang', name: '招商银行'},
        {id: 'zhaoshangshenzhen1', name: '招商银行深圳高新园支行'},
        {id: 'huaqi', name: '花旗银行'},
        {id: 'beijing', name: '北京中国银行'},
        {id: 'jiaotong', name: '交通银行'},
        {id: 'la', name: 'LA银行'},
        {id: 'nongye', name: '农业银行'},
        {id: 'else', name: '其他'}
      ],
      transactionForm: {
        id: "",
        status: "",
        partialPayment: ""
      },
      url: "",
      depositData: [],
      amount: 0,
      totalAmount: 0,
      multipleSelection: [],
      ownerOrgNames: [],
      transactionIds: [],
      auditStatus: [
        { id: "UNAUDITED", name: "未审核" },
        { id: "CANCELLATION", name: "已作废" },
        { id: "AUDITED", name: "已审核" }
      ],
      descriptions: [
        { id: "线下支付宝充值", name: "线下支付宝充值" },
        { id: "银行转账充值", name: "银行转账充值" },
        { id: "其他充值", name: "其他充值" },
        { id: "通联充值", name: "通联充值" }
      ],
      operators: [
        { id: "客户方", name: "客户方" },
        { id: "服务方", name: "服务方" }
      ],
      depositForm: {
        id: "",
        onlinePaymentId: "",
        accountRemark: "",
        amount: "",
        createDate: "",
        currency: "",
        customerOrgName: "",
        paymentTool: "Offline_Alipay",
        system: "",
        operator: "",
        bank: '',
        remarks: ""
      },
      imgListCertificateImgs: [],
      certificateImg: null,
      rules: {
        accountRemark: [
          { required: true, message: "请输入付款账户", trigger: "blur" }
        ],
        amount: [
          { required: true, message: "请输入充值金额", trigger: "blur" },
          {
            pattern: /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/,
            message: "充值金额只能为数字，并且不能小于零",
            trigger: "blur"
          }
        ],
        bank: [{ validator: checkBank, trigger: "blur" }],
        actualAccountTime: [{ validator: checkActualTime, trigger: "blur" }]

      },
      formLabelWidth: "120px",
      dialogShow: false,
      dialogVisible: false,
      isHasBeenPayment: false,
      imgDialogShow: false,
      dialogFormVisible: false,
      totalNums: 0,
      pageSize: 10,
      currentPage: 1 //分页
    };
  },
  created() {
    setTimeout(() => {
      this.initOrgOwnerByOrgId();
      this.offlineDeposit();
    }, 500);
  },
  computed: {
    pageConfig: {
      get: function() {
        return this.$store.state.pageConfig;
      },
      set: function(value) {
        return this.setConfig(value);
      }
    }
  },
  filters: {
    formatTime(value) {
      if (!value) return "";
      return (
        new Date(value).getFullYear() +
        "-" +
        ("0" + (new Date(value).getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + new Date(value).getDate()).slice(-2) +
        " " +
        ("0" + new Date(value).getHours()).slice(-2) +
        ":" +
        ("0" + new Date(value).getMinutes()).slice(-2) +
        ":" +
        ("0" + new Date(value).getSeconds()).slice(-2)
      );
    }
  },
  watch: {},
  methods: {
    ...mapMutations({
      setConfig: "setPageConfig"
    }),
    changeCertificateImg(file, fileList) {
      if (file.raw.size > 1024 * 1024 * 10) {
        this.$message.error("单张照片限制最大10M");
        this.imgListCertificateImgs = [];
      } else {
        this.certificateImg = file.raw;
      }
    },
    rmCertificateImg(file, fileList) {
      this.certificateImg = null;
    },
    // 表尾合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = "合计";
          return;
        }
        if (column.property === "amount") {
          sums[index] = this.totalAmount.toFixed(2); // 这个值应该是后台计算好返回到前台的
        } else {
          sums[index] = "";
        }
      });
      return sums;
    },
    handleClose() {
      this.dialogShow = false;
    },
    formatSytem(data) {
      switch (data.system) {
        case "TMS":
          return "TMS物流系统";
          break;
        case "WMS":
          return "WMS仓库系统";
          break;
        case "PP":
          return "小包物流系统";
          break;
      }
    },
    formatAuditStatus(data) {
      switch (data.status) {
        case "UNAUDITED":
          return "未审核";
          break;
        case "AUDITED":
          return "已审核";
          break;
        case "CANCELLATION":
          return "已作废";
          break;
      }
    },
    onSubmit() {
      this.conditions.currentPage = 1;
      this.offlineDeposit();
    },
    offlineDeposit() {


      this.conditions.auditStatus = !this.conditions.auditStatus ? null : this.conditions.auditStatus

      this.$request1({
        method: 'post',
        url: '/offlinedeposit/query',
        data: {
          txId: this.conditions.id,
          ownerOrgId: this.conditions.ownerOrgName,
          accountRemark: this.conditions.accountRemark,
          systemId: this.conditions.system,
          startTime: this.conditions.startDate,
          endTime: this.conditions.endDate,
          serviceType: this.conditions.serviceType!=null && this.conditions.serviceType==1,
          currentPage: this.conditions.currentPage,
          pageSize: this.conditions.pageSize,
          status:
            this.conditions.serviceType == 0
              ? "UNAUDITED"
              : this.conditions.auditStatus,
          description: this.conditions.description,
          operator: this.conditions.operator
        }
      })
        .then(res => {
          if (res.data.success) {
            this.depositData = res.data.data.offlineDepositDtos;
            this.totalAmount = res.data.data.totalAmount;
            this.amount = res.data.data.totalAmount;
            this.totalNums = res.data.total;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    batchAudit() {
      if (this.transactionIds.length == 0) {
        this.$message({
          message: "请选择线下充值记录",
          type: "error"
        });
        return;
      }
      this.$confirm("请仔细核对，审核后无法修改", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'GET',
            url: '/offlinedeposit/audit',
            params: {
              ids: this.transactionIds.toString()
            }
          })
            .then(res => {
              console.log(res);
              if (res.data.success) {
                this.$notify({
                  title: "成功",
                  message: "充值金额已审核，充值成功",
                  type: "success"
                });
                this.offlineDeposit();
                this.transactionIds = new Array();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.data.message
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    cancellation() {
      if (this.transactionIds.length == 0) {
        this.$message({
          message: "请选择线下充值记录",
          type: "error"
        });
        return;
      }
      this.$confirm("请仔细核对，作废后将无法还原!", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$request1({
            method: 'GET',
            url: '/offlinedeposit/cancellation',
            params: {
              ids: this.transactionIds.toString()
            }
          })
            .then(res => {
              console.log(res);
              if (res.data.success) {
                this.$notify({
                  title: "成功",
                  message: "已选线下充值已作废",
                  type: "success"
                });
                this.offlineDeposit();
                this.transactionIds = new Array();
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.data.message
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    editOfflineDeposit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.depositForm.paymentTool=='BankTransfer'){
            if(!this.depositForm.bank){
              this.$message.error('请选择银行类型');
              return false;
            }
          }else{
            this.depositForm.bank = '';
          }

          if (
            this.editImg &&
            (this.certificateImg == "" || this.certificateImg === null)
          ) {
            this.$alert("请上传凭证", "提示", {
              confirmButtonText: "确定",
              type: "warning"
            });
            return false;
          }
          // console.log(this.depositForm);

          var formData = new FormData();
          for (var key in this.depositForm) {
            formData.append(key, this.depositForm[key]==null? '' : this.depositForm[key]);
          }          
          if(this.certificateImg){
            formData.append("voucherImg", this.certificateImg);          
          }
          
          this.$request1({
            method: 'POST',
            url: '/offlinedeposit/edit',
            data: formData,
            withCredentials: true
          })
            .then(res => {
              // console.log(res);
              if (res.data.success) {
                this.$notify({
                  title: "成功",
                  message: "修改成功",
                  type: "success"
                });
                this.offlineDeposit();
                this.$refs[formName].resetFields();
                this.emptyForm();
                this.dialogFormVisible = false;
              } else {
                this.$notify.error({
                  title: "错误",
                  message: res.data.message
                });
              }
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 获取当前组织ID 下所有的货主
    initOrgOwnerByOrgId() {
      this.$request1({
        method: 'GET',
        url: '/transaction/queryOrgOwner'
      })
        .then(res => {
          console.log(res);
          if (res.data.success) {
            console.log(res);
            this.gone = true;
            this.ownerOrgNames = res.data.data;
          } else {
            this.gone = false;
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        })
        .then(res => {
          console.log(res);
          if (res.data.success) {
            this.ownerOrgNames = res.data.data;
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    // 多选
    handleSelectionChange(val) {
      this.totalAmount = 0;
      this.multipleSelection = val;
      this.transactionIds = new Array();
      if (this.conditions.serviceType == "线下充值") {
        val.forEach((item, index) => {
          if (item.status == "UNAUDITED") {
            this.transactionIds.push(item.id);
          }
          this.totalAmount += item.amount;
        });
        if (val.length == 0) {
          this.totalAmount = this.amount;
        }
      } else {
        val.forEach((item, index) => {
          this.transactionIds.push(item.id);
          this.totalAmount += item.amount;
        });
        if (val.length == 0) {
          this.totalAmount = this.amount;
        }
      }
    },
    //分页
    handleSizeChange(val) {
      this.conditions.pageSize = val;
      this.conditions.currentPage = 1;
      this.offlineDeposit();
    },
    handleCurrentChange(val) {
      this.conditions.currentPage = val;
      this.offlineDeposit();
    },
    checkImg() {
      let src = event.target.src;
      if (src === "data:image/png;base64,null") {
        return;
      }
      this.imgDialogShow = true;
      var imgContent = document.getElementById("imgContent");
      imgContent.src = src;
    },
    closeModal() {
      this.imgDialogShow = false;
    },
    offlineDepositEdit(row) {
      this.dialogFormVisible = true;
      this.depositForm.id = row.id;
      this.depositForm.onlinePaymentId = row.onlinePaymentId;
      this.depositForm.accountRemark = row.accountRemark;
      this.depositForm.amount = row.amount;
      this.depositForm.createDate = row.createDate;
      this.depositForm.currency = row.currency;
      this.depositForm.customerOrgName = row.customerOrgName;
      this.depositForm.remarks = row.remark;
      this.depositForm.bank = row.bank;
      // this.depositForm.actualAccountTime = row.actualAccountTime + '';
      this.$set(this.depositForm, 'actualAccountTime', row.actualAccountTime)

      if (row.description == "线下支付宝充值") {
        this.depositForm.paymentTool = "Offline_Alipay";
      } else if (row.description == "银行转账充值") {
        this.depositForm.paymentTool = "BankTransfer";
      } else if (row.description == "其他充值") {
        this.depositForm.paymentTool = "Rests";
      }else{
        this.depositForm.paymentTool = "";
      }
      this.depositForm.system = row.system;
      this.depositForm.img = row.voucherImg;
      this.depositForm.operator = row.operator;
    },
    //清空表单数据
    emptyForm() {
      this.dialogFormVisible = false;
      this.depositForm.id = "";
      this.depositForm.onlinePaymentId = "";
      this.depositForm.accountRemark = "";
      this.depositForm.amount = "";
      this.depositForm.createDate = "";
      this.depositForm.currency = "";
      this.depositForm.customerOrgName = "";
      this.depositForm.paymentTool = "Offline_Alipay";
      this.depositForm.system = "";
      this.depositForm.remarks = "";
      this.editImg = false;
      this.certificateImg = "";
      this.depositForm.operator = "";
    },
    //清除验证
    close(formRule) {
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    }
  }
};
</script>

<style lang="scss">
.in {
  color: #78c9a4;
}
.out {
  color: #eca6af;
}
.iconfont {
  font-size: 12px;
  &:hover {
    cursor: pointer;
    color: #74beff;
  }
}
.modal {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 2000;
  .modal-dialog {
    width: 100%;
    margin: 15% auto;
    transition: transform 0.3s ease-out;
    transform: translateY(-25%);
    .modal-content {
      position: relative;
      text-align: center;
      overflow: hidden;
      .img-wrapper {
        position: relative;
        display: inline-block;
        padding: 30px;
        .close {
          position: absolute;
          top: -5px;
          right: -30px;
          font-size: 30px;
          color: #f5f5f5;
          cursor: pointer;
        }
      }
    }
  }
}
.sub-title {
  color: #646464;
  font-size: 14px;
}
// .el-select .el-input {
//   width: 130px;
// }
.input-with-select .el-input-group__prepend {
  background-color: #fff;
}
.img-content {
  position: relative;
  display: inline-block;
  .mask {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    display: none;
    > i {
      z-index: 999;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
    }
  }
  &:hover {
    .mask {
      display: flex;
      transition: all 0.3s;
      > i {
        color: #ffffff;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/offlinedeposit/offlinedeposit.vue